import request from '@/utils/request';

/**
 * 作品上映排期页（DEV-15088）
 * - CMS 侧：配置的增删改查，需要登录（权限 dp:schedulePage:list），后端取当前用户的 dept 隔离，前端不传公司
 * - 观众页：匿名读取配置（/open/schedulePage/{pageKey}）
 * 注意作品 ID 有两套：CMS 保存时传 DP 的 movieId，后端解析出 EP 的 eglMovieId；影院一律是 EP 的 eglCinemaId
 */

// CMS：配置列表（按更新时间倒序）
export function listSchedulePageService() {
  return request({
    url: '/dp/schedulePage/list',
    method: 'get',
  });
}

// CMS：单条配置详情（含 cinemas）
export function getSchedulePageService(pageKey) {
  return request({
    url: `/dp/schedulePage/${encodeURIComponent(pageKey)}`,
    method: 'get',
  });
}

// CMS：新建，data 为 pageKey
export function createSchedulePageService(data) {
  return request({
    url: '/dp/schedulePage',
    method: 'post',
    data,
  });
}

// CMS：更新（movieId 会被后端忽略，作品不能改；cinemas 整体替换）
export function updateSchedulePageService(pageKey, data) {
  return request({
    url: `/dp/schedulePage/${encodeURIComponent(pageKey)}`,
    method: 'put',
    data,
  });
}

// CMS：公开 / 停止公开（停止后公开链接返回 404，配置保留）
export function setSchedulePageEnabledService(pageKey, enabled) {
  return request({
    url: `/dp/schedulePage/${encodeURIComponent(pageKey)}/enabled?enabled=${enabled ? 'true' : 'false'}`,
    method: 'put',
  });
}

// CMS：影院联系方式（DP 影院主数据），添加影院时预填电话；DP 没有的影院不在结果里
export function getCinemaContactsService(eglCinemaIds) {
  return request({
    url: '/dp/schedulePage/cinemaContacts',
    method: 'get',
    params: { eglCinemaIds: eglCinemaIds.join(',') },
  });
}

// CMS：删除
export function deleteSchedulePageService(pageKey) {
  return request({
    url: `/dp/schedulePage/${encodeURIComponent(pageKey)}`,
    method: 'delete',
  });
}

/**
 * 观众页：匿名读取配置
 * 不走 request.js：其拦截器在 code !== 200 时会弹 Element 的错误通知，观众页需要自己渲染「页面不存在」。
 * 页面不存在 / 已删除 / 停止公开时后端返回 HTTP 200 + {code:404}，此时抛出 status 为 404 的错误。
 */
export async function getPublicSchedulePageService(pageKey) {
  const res = await fetch(
    `${import.meta.env.VITE_APP_BASE_API}/open/schedulePage/${encodeURIComponent(pageKey)}`,
    { headers: { Accept: 'application/json' } },
  );
  if (res.status === 404) throw Object.assign(new Error('not found'), { status: 404 });
  if (!res.ok) throw Object.assign(new Error(`HTTP ${res.status}`), { status: res.status });
  const body = await res.json();
  if (body?.code === 404) throw Object.assign(new Error(body.msg || 'not found'), { status: 404 });
  if (body?.code !== 200 || !body.data) {
    throw Object.assign(new Error(body?.msg || 'error'), { status: body?.code || 500 });
  }
  return body.data;
}
